import { Button } from '@/fsd/shared/ui';
import BackArrow from '@/fsd/shared/ui/icons/back-arrow';
import cx from 'classnames';
import React, { ReactNode } from 'react';
import { useNavigate } from 'react-router-dom';
import styles from './TitledTablePage.module.scss';
import cl from 'classnames';

interface IProps {
  title: string;
  children: ReactNode;
  showBackButton?: boolean;
  backLink?: string;
  className?: string;
}

const TitledTablePage = ({
  title,
  children,
  showBackButton,
  backLink,
  className,
}: IProps) => {
  const navigate = useNavigate();

  const onBackLinkClick = (link?: string) => {
    if (link) navigate(link);
    else navigate(-1);
  };

  return (
    <main className={styles.pageMain}>
      <div className={styles.topPanel}>
        <div
          className={cx(
            styles.topPanelTitle,
            (showBackButton || backLink) && styles.withBackButton
          )}
        >
          {(showBackButton || backLink) && (
            <Button
              className={styles.backButton}
              onClick={() => onBackLinkClick(backLink)}
            >
              <BackArrow />
            </Button>
          )}
          <h1 className={styles.titleText} data-testid="page-title">
            {title}
          </h1>
        </div>
      </div>
      <div className={cl(styles.content, className)}>{children}</div>
    </main>
  );
};

export default TitledTablePage;
